module.exports = __webpack_public_path__ + "static/media/letterheadFooter_1706788148.7c69365d.png";